// src/utils/matchupFilters.js
// ตัวกรองกอง log สำหรับแผง matchup: ย้อนหลังกี่วัน และเอาเฉพาะประเภทไหน
//
// ประเภทมาจากคอลัมน์ Type ในชีทตรงๆ (ไฟล์ปัจจุบันมี Scrim / s.Taiwan / RPL / Coda)
// ไม่จับกลุ่มให้เอง เพราะ "ซ้อมกับแข่ง" ของแต่ละทีมนับไม่เหมือนกัน — โชว์ตามที่คีย์ไว้
// แล้วให้โค้ชเลือกเองว่าจะดูอันไหน
import { normalizeYmd, playedDates } from "./dashboardDates";

export const WINDOW_CHOICES = [7, 30, 90];

export function gameTypesInPool(games) {
  const acc = new Map();
  for (const g of Array.isArray(games) ? games : []) {
    const type = String(g?.type || "").trim();
    if (!type || type === "ไม่พบข้อมูล") continue;
    const key = type.toLowerCase();
    const slot = acc.get(key) || { type, key, count: 0 };
    slot.count += 1;
    acc.set(key, slot);
  }
  return [...acc.values()].sort((a, b) => b.count - a.count || a.type.localeCompare(b.type));
}

/** วันล่าสุดที่ "เล่นไปแล้วจริง" ในกองนี้ ใช้เป็นจุดตั้งต้นของหน้าต่างย้อนหลัง */
export function anchorDate(games) {
  return playedDates(games).latest;
}

export function shiftDaysBack(ymd, days) {
  const y = Number(String(ymd).slice(0, 4));
  const m = Number(String(ymd).slice(4, 6));
  const d = Number(String(ymd).slice(6, 8));
  if (!y || !m || !d) return "";
  const dt = new Date(y, m - 1, d - days + 1); // นับวันล่าสุดรวมเป็นวันที่ 1
  return `${dt.getFullYear()}${String(dt.getMonth() + 1).padStart(2, "0")}${String(dt.getDate()).padStart(2, "0")}`;
}

/**
 * @param days 0 = ไม่ตัดตามวัน | 7/30/90 = ย้อนหลังจากเกมล่าสุดในกอง
 * @param type "all" = ทุกประเภท | ค่าอื่น = เทียบกับคอลัมน์ Type แบบไม่สนตัวพิมพ์
 */
export function filterMatchupPool(games, { days = 0, type = "all" } = {}) {
  let pool = Array.isArray(games) ? games : [];

  if (type && type !== "all") {
    const want = String(type).toLowerCase();
    pool = pool.filter((g) => String(g?.type || "").trim().toLowerCase() === want);
  }

  if (days > 0) {
    const anchor = anchorDate(pool);
    if (!anchor) return [];
    const from = shiftDaysBack(anchor, days);
    pool = pool.filter((g) => {
      const d = normalizeYmd(g?.Date);
      return d && d >= from && d <= anchor;
    });
  }

  return pool;
}
